import createAsyncActions from 'shared/redux/helpers/create-async-actions';

const ACTIONS = createAsyncActions('CLIENT.VIDEO_URLS.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

const fetchVideoUrls = (videoItem, force = false) => (dispatch, getState) => {
  const { videoUrlsCache, appSettings } = getState();

  if (!force && (!videoItem || videoUrlsCache[videoItem.id])) {
    return;
  }

  const params = { videoItem };

  dispatch(START(params));

  /*
   * When videoItem is a bought video response from member/info and original video is too far in list
   * and wasn't loaded yet
   * */
  if (videoItem.dgsInfo && !videoItem.getVideoUrls) {
    return Promise.resolve();
  }

  return videoItem.getVideoUrls(appSettings.instance).then(
    function(response) {
      dispatch(SUCCESS(params, response));
      return response;
    },

    function(response) {
      dispatch(FAIL(params, response));
    },
  );
};

export default fetchVideoUrls;
